import * as React from 'react';
import './ResultListItem.css';
import SearchResult from './SearchResult';

interface Props {
    result: SearchResult;
    query: string;
}

export default class ResultListItem extends React.Component<Props> {

    public render(): React.ReactNode {
        return (
            <tr className="ResultListItem">
                <td className="_Greek">{this.props.result.greek}</td>
                <td><div dangerouslySetInnerHTML={{ __html: this.quickHighlight(this.props.result.definition, this.props.query) }} /></td>
            </tr>
        );
    }

    private quickHighlight(text: string, highlightText: string): string {
        return text.replace(highlightText, `<span class="_Highlighted">${highlightText}</span>`);
    }
}
